import { useState } from 'react';
import { Outlet, Link } from "react-router-dom";
import { PageNames } from "../Assets/variables";

export default function APIPage({ apiInfo }) {
    const [activeTab, setActiveTab] = useState('');

    const setActiveTabItem = (tabName = '') => {
        setActiveTab(tabName);
    }

    return (
        <div className="api-container">
            <div className="api-tabs">
                <div className="api-tabs-header">
                    <Link
                        to={`/${PageNames.Catalog}`}
                        className="api-tabs-header__back-button">
                    </Link>
                    <h1 id="api-tabs-header__title">{apiInfo.apiTitle}</h1>
                    {apiInfo.beta &&
                        <h2 id="api-beta-tag">(Beta)</h2>
                    }
                </div>
                <div id="api-tabs-tab-group" className="tabs">
                    { apiInfo.tabs.map(tab => (
                        <Link
                            to={tab.url}
                            key={tab.url}
                            className={"api-tabs-tab " + (tab.url === activeTab ? 'active' : '')}>
                                {tab.displayName}
                        </Link>
                    )) }
                </div>
            </div>
            <div className="api-panels">
                <Outlet context={{ setActiveTabItem, apiInfo }} />
            </div>
        </div>
    )
}